import { render, staticRenderFns } from "./RelatedDocsSectionValueEditor.vue?vue&type=template&id=14def466"
import script from "./RelatedDocsSectionValueEditor.vue?vue&type=script&lang=ts"
export * from "./RelatedDocsSectionValueEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports